import React from "react";
import {SelectedContainer, SelectStyled} from "../styles/GlobalStyles";

export default function Select({id, options, name, placeholder, defaultValue, change}) {
   return ( 
      <SelectedContainer> 
         <SelectStyled required id={id} name={name} defaultValue={defaultValue} onChange={change}>
            {placeholder && (
               <option value={placeholder.value} disabled>
                  {placeholder.name}
               </option>
            )}
            {options &&
               options.map((item) => (
                  <option value={item.value} key={`${name}${item.value}`}>
                     {item.name}
                  </option>
               ))}
         </SelectStyled>
         <img src={require("../assets/icons/down_bread.png")} className="arrow" alt="" />
      </SelectedContainer>
   );
}

Select.defaultProps = {
   defaultValue: "0",
   placeholder: {value: "0", name: ""},
   optons: [],
   name: "name",
   id: "id",
};
